module.exports = __webpack_public_path__ + "static/conceptSmall5-b9e3edf253652708701b544861855055.jpg";